var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13C17.8211 13 19.5 11.3211 19.5 9.25C19.5 7.17893 17.8211 5.5 15.75 5.5C13.6789 5.5 12 7.17893 12 9.25C12 11.3211 13.6789 13 15.75 13Z",
    fill: "url(#paint0_linear_5112_718)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.21134C9.90592 8.21134 8.20833 9.90844 8.20833 12.0019C8.20833 14.0954 9.90592 15.7925 12 15.7925C14.0941 15.7925 15.7917 14.0954 15.7917 12.0019C15.7917 9.90844 14.0941 8.21134 12 8.21134ZM5.5 12.0019C5.5 8.4131 8.41015 5.50378 12 5.50378C15.5899 5.50378 18.5 8.4131 18.5 12.0019C18.5 15.5907 15.5899 18.5 12 18.5C8.41015 18.5 5.5 15.5907 5.5 12.0019Z",
    fill: "url(#paint1_linear_5112_718)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4966 11.8025C17.812 12.5368 16.8362 12.996 15.753 12.996C15.7217 12.996 15.6905 12.9956 15.6594 12.9949C15.7458 12.6772 15.7919 12.343 15.7919 11.9979C15.7919 9.95358 14.1735 8.28722 12.1479 8.21015C12.4458 7.17174 13.1801 6.31787 14.1397 5.85986C16.6196 6.72371 18.4152 9.04794 18.4966 11.8025Z",
    fill: "url(#paint2_linear_5112_718)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.748 13C17.8191 13 19.498 11.3211 19.498 9.25C19.498 7.17893 17.8191 5.5 15.748 5.5C13.677 5.5 11.998 7.17893 11.998 9.25C11.998 11.3211 13.677 13 15.748 13Z",
    fill: "url(#paint3_radial_5112_718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5112_718",
    x1: 12.1487,
    y1: 5.5,
    x2: 18.2895,
    y2: 11.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0087EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63FFF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5112_718",
    x1: 18.5,
    y1: 5.50378,
    x2: 5.50374,
    y2: 18.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0051AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666238,
    stopColor: "#0087EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5112_718",
    x1: 14.4727,
    y1: 7.99494,
    x2: 17.9491,
    y2: 12.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74BF4B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BF4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5112_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.498 13) rotate(-135) scale(10.6066 10.6021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCEB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666962,
    stopColor: "#00BCEB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0a0a1d9b18e6806fb1649a99580b47e3.svg";
export { ForwardRef as ReactComponent };